import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { SalonmonsterHttpClient } from './salonmonster-http-client';

import { ErrorHandlerService } from './error-handler.service';
import { UserService } from './user.service';
import { Observable, throwError } from 'rxjs';
import { ENV_CONFIG } from '../../bin/env.config';
import { catchError, map } from 'rxjs/operators';
import { List } from 'immutable';

@Injectable()
export class StripeSubscriptionService extends SalonmonsterHttpClient {
  constructor(
    http: HttpClient,
    userService: UserService,
    protected override errorHandlerService: ErrorHandlerService
  ) {
    super(http, userService, errorHandlerService);
  }

  public fetchStripeCustomerID(): Observable<any> {
    const url = `${ENV_CONFIG.API_ROOT}/stripe-subscriptions/get-subscription-info`;

    return this.get(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorHandlerService.handleError(error));
      })
    );
  }

  public fetchStripeSubscriptionInfo(): Observable<any> {
    const url = `${ENV_CONFIG.API_ROOT}/stripe-subscriptions/list-subscriptions`;

    return this.get(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorHandlerService.handleError(error));
      })
    );
  }

  public createCustomerPortalSession(
    stripeCustomerID: string
  ): Observable<any> {
    const url = `${ENV_CONFIG.API_ROOT}/stripe-subscriptions/create-customer-portal-session`;

    return this.post(url, { stripeCustomerID }).pipe(
      map((data) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorHandlerService.handleError(error));
      })
    );
  }

  public createCustomerSubscribeSession(
    stripeCustomerID: string,
    planType: string,
    quantity: number,
    currency: string
  ): Observable<any> {
    const url = `${ENV_CONFIG.API_ROOT}/stripe-subscriptions/create-customer-subscribe-session`;

    return this.post(url, {
      stripeCustomerID,
      planType,
      quantity,
      currency,
    }).pipe(
      map((data) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorHandlerService.handleError(error));
      })
    );
  }

  public createStripeCustomer(): Observable<any> {
    const url = `${ENV_CONFIG.API_ROOT}/stripe-subscriptions/customer`;

    return this.post(url, {}).pipe(
      map((data) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorHandlerService.handleError(error));
      })
    );
  }

  public getPlanQuantity(): Observable<any> {
    const url = `${ENV_CONFIG.API_ROOT}/stripe-subscriptions/quantity`;
    return this.get(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorHandlerService.handleError(error));
      })
    );
  }

  public updateSubscriptionToAnnual(
    subscriptionID: string,
    subscriptionItemID: string,
    currency: string
  ): Observable<any> {
    const url = `${ENV_CONFIG.API_ROOT}/stripe-subscriptions/upgrade-to-annual`;
    return this.post(url, {subscriptionID, subscriptionItemID, currency }).pipe(
      map((data) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorHandlerService.handleError(error));
      })
    );
  }
}
